
































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditCriteres from '@/components/flux/edit/EditCriteres.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray, toNumberDictionary } from '@/utils/groupBy'

@Component({
  name: 'ReadCriteres',    
  components:{EditCriteres},  
  props: {
    loading:{ 
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default: getDefaultAloFlux
    },
    dispoEditable:{
      type:Boolean,
      default:true      
    },
    segmentEditable:{
      type:Boolean,
      default:true      
    },
    stockEditable:{
      type:Boolean,
      default:true      
    },
    entrepotEditable:{
      type:Boolean,
      default:true      
    },
    transporteurEditable:{
      type:Boolean,
      default:true      
    },
    dispoVisible:{
      type:Boolean,
      default:true      
    },    
    segmentVisible:{
      type:Boolean,
      default:true      
    },    
    stockVisible:{
      type:Boolean,
      default:true      
    },   
    entrepotVisible :{
      type:Boolean,
      default:true      
    },   
    transporteurVisible:{
      type:Boolean,
      default:true      
    },   
  }
})
export default class ReadCriteres extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean
  private dispoEditable!:boolean
  private segmentEditable!:boolean
  private stockEditable!:boolean
  private entrepotEditable!:boolean
  private transporteurEditable!:boolean  
  private dispoVisible!:boolean
  private segmentVisible!:boolean
  private stockVisible!:boolean
  private entrepotVisible!:boolean  
  private transporteurVisible!:boolean  
  

  get editable() {
    return this.dispoEditable || this.segmentEditable || this.stockEditable || this.entrepotEditable || this.transporteurEditable
  }

  get dispoExporteGroup(){
    //@ts-ignore    
    return toSubArray(this.$store.myGetters.disposList,this.$vuetify.breakpoint.mdAndUp?3:2)
  }

  get exludedDispoDic(){
    return toNumberDictionary(this.flux.excludedDispo,id => id)
  }

  get disposList(){
    //@ts-ignore    
    return this.$store.myGetters.disposList
  }

  get transportersList(){
    return this.$store.myGetters.transportersList
  }

  edit() { (this.$refs.editCriteres as EditCriteres).edit(this.flux) }

}
